function escapeHtml(unsafe) {
    return unsafe
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
}

function unescapeHtml(safe) {
    return safe
        .replace(/&lt;/g, "<")
        .replace(/&gt;/g, ">")
}

function scrollTo(section) {
    if (section === "response") {
        // Remove loading animation
        document.querySelector('.loading-validator').classList.remove('d-block');
        document.querySelector('.upload-box-input').classList.remove('d-none');
        document.querySelector('.upload-box').classList.remove('is-loading');
        document.querySelector('.upload-box').classList.add('is-success');

        // Go to validated result
        const targetPosition = document.querySelector("#validator-response").getBoundingClientRect().top + window.scrollY - 76;
        window.scroll({ top: targetPosition, behavior: 'smooth' });
    } else if (section === "top") {
        window.scroll({ top: 0, behavior: 'smooth' });
    }
}

ko.bindingHandlers.codemirror = {
    init: function(element, valueAccessor, allBindings, viewModel, bindingContext) {
        var options = viewModel.options || {};
        options.value = ko.unwrap(valueAccessor());
        element.editor = CodeMirror.fromTextArea(element, options);
        element.editor.on('change', function(cm) {
            var value = valueAccessor();
            value(cm.getValue());
        });
    },
    update: function(element, valueAccessor, allBindings, viewModel, bindingContext) {
        if (viewModel.allowSetValue()) {
            var observedValue = ko.unwrap(valueAccessor());
            if (element.editor) {
                element.editor.setValue(observedValue);
                element.editor.execCommand('goDocEnd');
                element.editor.refresh();
            }
        }
    }
};

ko.bindingHandlers.fileUpload = {
    init: function(element, valueAccessor) {
        element.addEventListener('change', () => valueAccessor()(element.files[0]));
        element.addEventListener('click', (event) => event.target.value = null);
    },
    update: function(element, valueAccessor) {
        if (ko.unwrap(valueAccessor()) === null) {
            const form = document.createElement('form');
            element.parentNode.insertBefore(form, element);
            form.appendChild(element);
            form.reset();

            form.parentNode.insertBefore(element, form);
            form.remove();
        }
    }
};

var VM = function () {
    var self = this;

    self.showResult = ko.observable(false);
    self.input = ko.observable('');
    self.emptyInput = ko.pureComputed(function(){
        return self.input() === "";
    });
    self.yamlInput = ko.observable();
    self.yamlStringified = ko.observable();
    self.status = ko.observable();

    self.options = { lineNumbers: true };
    self.allowSetValue = ko.observable(false);
    self.error = ko.observable('');
    self.errorLine = ko.observable();
    self.showRepairBtn = ko.observable(true);

    self.errorSize = ko.observable('');
    self.inputFile = ko.observable('');
    self.uploadFile = ko.observable(null);
    self.fileName = ko.pureComputed(function(){
        if (self.uploadFile()) {
            return self.uploadFile().name;
        }
    });

    // Tree View functions
    self.yamlTemplateOptions = ko.observableArray([
        { label: 'One space', value: 1 },
        { label: 'Two spaces', value: 2 },
        { label: 'Three spaces', value: 3 },
        { label: 'Four spaces', value: 4 },
        { label: 'Five spaces', value: 5 }
    ]);
    self.selectedYamlTemplate = ko.observable(2);
    self.selectedYamlTemplate.subscribe(function(newValue){
        parseYAML();
    });
    self.sortObject = ko.observable(false);
    self.sortObject.subscribe(function(newValue) {
        parseYAML();
    });
    
    // Validate & Format button
    self.validate = function () {
        self.resetObservables();
        // Show loading animation
        document.querySelector('.loading-validator').classList.add('d-block');
        parseYAML(500);
    }

    function parseYAML(timeout, file) {
        if (file) {
            inputOrFile(self.inputFile(), file);
        } else {
            self.uploadFile(null);
            inputOrFile(self.input());
        }

        function inputOrFile(x, file) {
            if (x) {
                try {
                    const source = yaml.parse(x, { logLevel: 'warn' });
                    self.yamlInput(source);
                } catch(err) {
                    self.error(err.name + ": " + err.message);
                    if (!file) {
                        if (err.linePos) {
                            self.errorLine(err.linePos[0].line);
                            document.querySelector('.textarea-codemirror textarea').editor.addLineClass(self.errorLine() - 1, "wrap", "mark");
                        }
                    }
                    self.status('Invalid YAML');
                    self.showResult(true);
                    scrollTo('response');
                    return;
                }
            }
        }

        if (self.yamlInput()) {
            var input = self.yamlInput();
            if (timeout) {
                self.showResult(false);
            }
            setTimeout(function() {
                self.showResult(true);
                self.yamlStringified(yaml.stringify(input, { indent: self.selectedYamlTemplate(), flowCollectionPadding: false, sortMapEntries: self.sortObject() }));
                document.querySelector('#yaml-view pre code').innerHTML = self.yamlStringified();

                document.querySelectorAll('#yaml-view pre code.hljs').forEach((block) => {
                    hljs.highlightBlock(block);
                });
                
                if (timeout) {
                    scrollTo('response');
                }
            }, timeout);
        }
    }

    self.resetObservables = function() {
        self.inputFile('');
        self.yamlInput('');
        self.yamlStringified('');
        self.status('');
        self.error('');
        self.errorSize('');
        if (self.errorLine()) {
            document.querySelector('.textarea-codemirror textarea').editor.removeLineClass(self.errorLine() - 1, "wrap", "mark");
            self.errorLine('');
        }
        self.showRepairBtn(true);
    }

    // Copy to clipboard button
    var copyCode = new ClipboardJS('#cpybutton', {
        text: function () {
            return self.yamlStringified();
        }
    });
    copyCode.on('success', function(e) {
        e.clearSelection();
        const cpyButton = new bootstrap.Tooltip(document.querySelector('#cpybutton'));
        cpyButton.show();
        setTimeout(() => cpyButton.hide(), 1000);
    });

    // Copy to clipboard as JSON button
    var copyJSON = new ClipboardJS('#cpyjsonbutton', {
        text: function () {
            return unescapeHtml(JSON.stringify(self.yamlInput(), null, self.selectedYamlTemplate()));
        }
    });
    copyJSON.on('success', function(e) {
        e.clearSelection();
        const cpyButton = new bootstrap.Tooltip(document.querySelector('#cpyjsonbutton'));
        cpyButton.show();
        setTimeout(() => cpyButton.hide(), 1000);
    });

    // Copy to clipboard for markdown button
    var mrkdStacktrace = new ClipboardJS('#mrkdbutton', {
        text: function () {
            return '```yaml\n' + self.yamlStringified() + '\n```';
        }
    });
    mrkdStacktrace.on('success', function (e) {
        e.clearSelection();
        const mrkdButton = new bootstrap.Tooltip(document.querySelector('#mrkdbutton'));
        mrkdButton.show();
        setTimeout(() => mrkdButton.hide(), 1000);
    });

    self.shareToolbox = ko.pureComputed({
        read: function () {
            var url = encodeURIComponent(window.location.href),
                title = encodeURIComponent(document.title),
                description = encodeURIComponent(document.getElementsByName('description')[0].getAttribute('content'));
            
            return { 
                facebook: 'https://www.facebook.com/sharer.php?u=' + url,
                twitter: 'https://x.com/intent/tweet?url=' + url + '&text=' + title,
                linkedin: 'https://www.linkedin.com/sharing/share-offsite/?url=' + url,
                email: 'mailto:?subject=' + title + '&body=' + description + ' Link: ' + url
            };
        },
        owner: this
    });

    // drag & drop
    self.formDragOver = function(data, event) {
        document.querySelector('.upload-box').classList.add('is-dragover');
    };
    self.formNotDragOver = function(data, event) {
        document.querySelector('.upload-box').classList.remove('is-dragover');
    };
    self.formDrop = function(data, event) {
        self.uploadFile(event.originalEvent.dataTransfer.files[0]);
        self.readUploadedFile();
    }

    // Read File
    self.readUploadedFile = function() {
        self.resetObservables();
        self.input('');
        document.querySelector('.textarea-codemirror textarea').editor.setValue("");
        document.querySelector('.textarea-codemirror textarea').editor.clearHistory();

        if (self.uploadFile()) {
            document.querySelector('.upload-box').classList.remove('is-success', 'is-error', 'is-error-type', 'is-error-size');
            document.querySelector('.upload-box-input').classList.add('d-none');
            document.querySelector('.upload-box').classList.add('is-loading');

            var fileExtension = self.uploadFile().name.split('.').pop();
            var fileTypeSupport = ['yml', 'yaml'];

            if (fileTypeSupport.indexOf(fileExtension) === -1) {
                setTimeout(function() {
                    document.querySelector('.upload-box-input').classList.remove('d-none');
                    document.querySelector('.upload-box').classList.remove('is-loading');
                    document.querySelector('.upload-box').classList.add('is-error', 'is-error-type');
                }, 500);
                return false;
            } else {
                if (self.uploadFile().size > 1048576 || self.uploadFile().size === 0) {
                    if (self.uploadFile().size > 1048576) {
                        self.errorSize("Error: Uploaded file size can not exceed 1 MB !");
                    } else {
                        self.errorSize("Error: Uploaded file is empty !");
                    }
                    setTimeout(function() {
                        document.querySelector('.upload-box-input').classList.remove('d-none');
                        document.querySelector('.upload-box').classList.remove('is-loading')
                        document.querySelector('.upload-box').classList.add('is-error', 'is-error-size');
                    }, 500);
                    return false;
                } else {
                    var reader = new FileReader();
                    reader.onloadend = function(e) {
                        var fileDataText = reader.result;
                        displayResult(fileDataText);
                    };
                    reader.readAsText(self.uploadFile());
                    return true;
                }
            }
        }
    }

    function displayResult(fileDataText) {
        self.inputFile(fileDataText);
        parseYAML(1000, true);
    }
}

document.addEventListener("DOMContentLoaded", function () {
    var vm = new VM();
    ko.applyBindings(vm, document.body);

    // Hljs more description
    const moreDescription = document.querySelector('.more-description');
    moreDescription.querySelectorAll('pre code').forEach((block) => {
        hljs.highlightBlock(block);
    });
});